import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { SfAppRoutingModule } from './sf-app-routing.module';
import { SfAppComponent } from './sf-app.component';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { metaReducers, reducers } from '../../reducers';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { authInterceptor } from '../../auth/interceptors/auth.interceptor';
import { SfCoreModule } from './core/sf-core.module';
import { SdProgressBarA11yComponent } from '../../shared/sd-progress-bar-a11y/components/sd-progress-bar-a11y/sd-progress-bar-a11y.component';
import { provideNoOpModalController } from '../../core/providers/no-op-modal-controller.provider';

@NgModule({
  declarations: [SfAppComponent],
  bootstrap: [SfAppComponent],
  imports: [
    BrowserModule,
    SfAppRoutingModule,
    BrowserAnimationsModule,
    EffectsModule.forRoot([]),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    environment.reduxToolsEnabled
      ? StoreDevtoolsModule.instrument({
          maxAge: environment.reduxMaxAge,
          logOnly: environment.production,
          serialize: true,
          connectInZone: true,
          actionsBlocklist: [
            '[SdSVG / Others] Sd Cache element Added',
            '[SdSVG] Sd Cache New Image Requested',
            '@ngrx/store/update-reducers',
          ],
        })
      : [],
    SfCoreModule,
    SdProgressBarA11yComponent,
  ],
  providers: [
    provideHttpClient(
      withInterceptors([authInterceptor]),
      withInterceptorsFromDi()
    ),
    provideNoOpModalController(),
  ],
})
export class SfAppModule {}
